import { NotificationBase } from './notification-base';

export class NotificationConversation extends NotificationBase {
  process(): void {
    if (!this.isCurrentPage()) {
      this.handleAlert();
    }
  }

  protected viewNotification(): void {
    this.navCtrl.navigateForward(`conversation/${this.item.channel_url}`);
  }

  private handleAlert(): void {
    this.showAlert();
  }

  private isCurrentPage(): boolean {
    const conversation = `/conversation/${this.item.channel_url}`;

    //  /conversation/20300
    return this.currentRoute() === conversation;
  }
}
